import { useForm } from "react-hook-form";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import { apiUrl } from "../../../ApiHelper/ApiUrl";

const AddExpenseHeadModal = ({
  modal,
  toggle,
  GetExpenseHeadList,
  modalData,
  setModalData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    expenseHeadType: [],
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    if (modal) {
      GetExpenseHeadType();
    }
    if (modalData) {
      reset({
        name: modalData?.name,
      });
    }
  }, [modalData, modal]);

  const GetExpenseHeadType = () => {
    const option = {
      method: "GET",
    }
    callApi(apiUrl.get_expense_head_type, option).then((res) => {
      if (res.status === true) {
        setState((state) => ({ ...state, expenseHeadType: res.data }));
      }
    })
  }

  const closeHandler = () => {
    setModalData({});
    toggle();
    reset();
  };

  const onSubmit = (data) => {
    const options = {
      method: "POST",
      data: { ...data, expenseHeadTypeId: state?.expenseHeadType?.find((item) => item?.name === "Supply")?.id },
    };
    if (modalData?.id) {
      let API = apiUrl?.update_expense_head + `?expenseHeadId=${modalData?.id}`;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          closeHandler();
          GetExpenseHeadList(1);
        } else {
          toast.error(response?.message);
        }
      });
    } else {
      let API = apiUrl?.add_expense_head;
      setIsLoading(true);
      callApi(API, options).then((response) => {
        setIsLoading(false);
        if (response?.status === true) {
          toast.success(response?.message);
          closeHandler();
          GetExpenseHeadList(1);
        } else {
          toast.error(response?.message);
        }
      });
    }
  };

  return (
    <Modal
      className="modal-dialog modal-dialog-centered modal-md"
      isOpen={modal}
      toggle={closeHandler}
    >
      <ModalHeader toggle={closeHandler}>
        {" "}
        <h4>{modalData?.id ? "Update" : "Add"} Expense Head</h4>
      </ModalHeader>
      <ModalBody>
        <form
          id="loginForm"
          className="tooltip-end-bottom"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="mb-3 filled form-group tooltip-end-top">
            <div>
              <label htmlFor="selectcat" className="form-label">
                Expense Head Name
              </label>
              <input
                className="form-control ps-2"
                placeholder="Enter Name"
                name="name"
                {...register("name", {
                  required: "This field is required",
                })}
              />
              <ErrorMessage message={errors?.name?.message} />
            </div>
            {/* <div>
              <label htmlFor="selectcat" className="form-label mt-2">
                Expense Head Type
              </label>
              <select
                className="form-control ps-2"
                placeholder="Type"
                name="type"
                {...register("expenseHeadTypeId", {
                  required: "This field is required",
                })}
              >
                <option className="d-none">Select Expense Head Type</option>
                {state?.expenseHeadType?.length > 0 ? state?.expenseHeadType.map((item) => {
                  return (
                    <option
                      key={item?.id}
                      value={item?.id}>{item?.name}</option>
                  );
                }) : <option disabled>No Type found</option>}
              </select>
              <ErrorMessage message={errors?.expenseHeadTypeId?.message} />
            </div> */}
          </div>
          <div className="modal-footer p-3">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
              onClick={closeHandler}
            >
              Cancel
            </button>
            <button className="btn btn-primary">
              {isLoading ? <Spinner /> : modalData?.id ? "Update" : "Add"}
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default AddExpenseHeadModal;
